var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("application-header-loader")
    : _c(
        "div",
        { staticClass: "row header vertical-flex-auto mb-lg-0 mb-4" },
        [
          _c("div", { staticClass: "col-xl-10 col-12" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col d-flex align-items-center mb-2" },
                [
                  _c("back-button", {
                    attrs: {
                      "fallback-route": "applications",
                      "section-route": "applications",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "client-name-header vertical-center" },
                    [
                      _c("applicant-avatar", {
                        attrs: {
                          "client-details": _vm.clientDetails,
                          registered: _vm.accountStatus === "active",
                          "avatar-initials": _vm.avatarInitials,
                          pending: _vm.applicationStatus === "pending",
                          verified: _vm.verified,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _vm.linkedProfiles.length
                              ? _c("applicant-redirectable-name", {
                                  attrs: {
                                    "linked-profiles": _vm.linkedProfiles,
                                    "application-id": _vm.applicationId,
                                    "applicant-name": _vm.fullName,
                                  },
                                })
                              : _c("h2", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.fullName) +
                                      "\n              "
                                  ),
                                ]),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.bottom",
                                    value: _vm.$t("application.applicationID"),
                                    expression:
                                      "$t('application.applicationID')",
                                    modifiers: { bottom: true },
                                  },
                                ],
                                staticClass: "mb-0 mx-2 bold text-primary-alt",
                                staticStyle: { "margin-top": "0.45rem" },
                              },
                              [
                                _vm._v(
                                  "\n                #" +
                                    _vm._s(_vm.applicationId) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "application-badges-container" },
                          [
                            _c("application-status-badge", {
                              staticClass: "float-left",
                              attrs: {
                                "application-status": _vm.applicationStatus,
                              },
                            }),
                            _vm._v(" "),
                            _vm.IS_APPLICATION_SYNCABLE(_vm.applicationId)
                              ? _c("application-sync-status-badge", {
                                  staticClass: "float-left ml-2",
                                  attrs: {
                                    "application-id": _vm.applicationId,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-auto my-auto forward" }, [
                _c("div", { staticClass: "application-last-saved-message" }, [
                  !_vm.saving
                    ? _c(
                        "div",
                        {
                          staticClass: "font-italic text-right text-gray w-100",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "application.applicationHeader.last-saved"
                                )
                              ) +
                              ":\n            "
                          ),
                          _c("refreshable-time-ago", {
                            attrs: { date: _vm.updatedAt },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "font-italic text-right text-gray w-100",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.words.saving")) +
                              "...\n          "
                          ),
                        ]
                      ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex client justify-content-end" },
                  [
                    _vm.clientUsername
                      ? _c("application-lock-button", {
                          attrs: {
                            "application-id": _vm.applicationId,
                            "client-username": _vm.clientUsername,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "p-0 d-none d-lg-flex" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-white btn-sm mr-2",
                            attrs: { "data-parsley-required": "false" },
                            on: { click: _vm.openValidWidgetPopover },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.validate")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown mr-2" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-sm btn-white dropdown-toggle clickable",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("global.words.actions")) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                              staticStyle: { overflow: "visible !important" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "create-request-package" },
                                [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName:
                                            "v-b-modal.bulk-request-modal",
                                          modifiers: {
                                            "bulk-request-modal": true,
                                          },
                                        },
                                      ],
                                      staticClass: "dropdown-item clickable",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "application.applicationHeader.createRequestPackage"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.e-sign-modal",
                                      modifiers: { "e-sign-modal": true },
                                    },
                                  ],
                                  staticClass: "dropdown-item clickable",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application.applicationHeader.createESignPackage"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.left",
                                      value: {
                                        title: _vm.noaDisabled,
                                        disabled: !_vm.noaDisabled,
                                      },
                                      expression:
                                        "{\n                    title: noaDisabled,\n                    disabled: !noaDisabled\n                  }",
                                      modifiers: { left: true },
                                    },
                                  ],
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCRARequestModal()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName:
                                            "v-b-modal.cra-request-modal",
                                          modifiers: {
                                            "cra-request-modal": true,
                                          },
                                        },
                                      ],
                                      staticClass: "clickable",
                                      class: { disabled: _vm.noaDisabled },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "application.applicationHeader.requestNoa"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "dropdown-divider d-none d-md-block",
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.manage-automations-modal",
                                      modifiers: {
                                        "manage-automations-modal": true,
                                      },
                                    },
                                  ],
                                  staticClass: "dropdown-item clickable",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc(
                                          "application.applicationHeader.muteAutomation",
                                          2
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item clickable",
                                  on: {
                                    click: _vm.handleChangelogSummaryClick,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-changelog.changelogSummary"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.rollback-status-modal",
                                      modifiers: {
                                        "rollback-status-modal": true,
                                      },
                                    },
                                  ],
                                  staticClass: "dropdown-item",
                                  class: {
                                    disabled: !_vm.isApplicationCompleted,
                                    clickable: _vm.isApplicationCompleted,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc(
                                          "application.applicationHeader.rollbackStatus"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.currentAgentIsCollaborator
                                ? [
                                    _c("div", {
                                      staticClass:
                                        "dropdown-divider d-none d-md-block",
                                    }),
                                    _vm._v(" "),
                                    !_vm.linkedProfiles.length
                                      ? _c("add-to-board-dropdown", {
                                          attrs: {
                                            "application-id": _vm.applicationId,
                                            "client-username":
                                              _vm.clientUsername,
                                            "agent-username": _vm.agentUsername,
                                          },
                                        })
                                      : [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item clickable",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "note"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.addNote"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item clickable",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "checklist"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.createChecklist"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item clickable",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "activity"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.createActivity"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item clickable",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "email"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.sendEmail"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showGenerateEmailOption()
                                ? _c("div", {
                                    staticClass:
                                      "dropdown-divider d-none d-md-block",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showGenerateEmailOption()
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName:
                                            "v-b-modal.generate-email-modal",
                                          modifiers: {
                                            "generate-email-modal": true,
                                          },
                                        },
                                      ],
                                      staticClass: "dropdown-item clickable",
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "12",
                                            width: "14",
                                            viewBox: "0 0 576 512",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("global.actions.autoCompose")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.clientUsername && _vm.applicationId
                          ? _c("bulk-request-modal", {
                              ref: "bulkRequestModal",
                              attrs: {
                                "application-id": _vm.applicationId,
                                "client-username": _vm.clientUsername,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("cra-request-modal", {
                          ref: "craRequestModal",
                          attrs: {
                            "application-id": _vm.applicationId,
                            "client-username": _vm.clientUsername,
                            "agent-username": _vm.agentUsername,
                            "application-info": _vm.applicationInfo,
                          },
                        }),
                        _vm._v(" "),
                        _c("manage-automations-modal", {
                          ref: "manageAutomationsModal",
                          attrs: {
                            "application-id": _vm.applicationId,
                            "client-username": _vm.clientUsername,
                            "agent-username": _vm.agentUsername,
                          },
                        }),
                        _vm._v(" "),
                        _c("show-subscription-modal", {
                          ref: "showSubscriptionModal",
                          attrs: {
                            "application-id": _vm.applicationId,
                            "client-username": _vm.clientUsername,
                            "agent-username": _vm.agentUsername,
                            subscription: _vm.subscription,
                          },
                        }),
                        _vm._v(" "),
                        _c("e-sign-modal", {
                          ref: "eSignModal",
                          attrs: {
                            "application-id": _vm.applicationId,
                            "client-username": _vm.clientUsername,
                            "agent-username": _vm.agentUsername,
                          },
                        }),
                        _vm._v(" "),
                        _vm.linkedProfiles.length &&
                        _vm.currentAgentIsCollaborator
                          ? _c("client-profile-quick-actions-modal", {
                              ref: "clientProfileQuickActionsModal",
                              attrs: {
                                "loading-profile": _vm.loadingProfile,
                                "quick-action-name": _vm.selectedQuickAction,
                                "client-profiles": _vm.linkedProfiles,
                                "linked-client-profile":
                                  _vm.selectedClientProfile,
                                "application-id": _vm.applicationId,
                                "client-username": _vm.clientUsername,
                                "agent-username": _vm.agentUsername,
                              },
                              on: { select: _vm.handleSelectedProfile },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("generate-email-modal", {
                          ref: "generateEmailModal",
                          attrs: {
                            "show-tool-tip": true,
                            "button-text": "send",
                            "client-profile": _vm.clientDetails,
                            "application-id": _vm.applicationId,
                            "email-signature": _vm.ACCOUNT_EMAIL_SIGNATURE,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-modal",
                          {
                            attrs: {
                              id: "rollback-status-modal",
                              title: _vm.$t(
                                "application.applicationHeader.rollbackStatus"
                              ),
                              "hide-footer": "",
                              centered: "",
                            },
                          },
                          [
                            _c("div", { staticClass: "d-block text-justify" }, [
                              _c("p", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "application.applicationHeader.rollbackDisclaimer"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-right" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "white" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$bvModal.hide(
                                            "rollback-status-modal"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("global.words.cancel"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.confirmRollbackStatus },
                                    },
                                    [
                                      _vm.rollbackLoading
                                        ? _c("b-spinner", {
                                            attrs: { small: "" },
                                          })
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.actions.confirm")
                                              )
                                            ),
                                          ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropleft d-lg-none d-flex" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "grey-text text-darken-4 clickable d-lg-none",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("more_vert"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          staticStyle: { overflow: "visible !important" },
                          attrs: {
                            id: "application-actions-dropdown--responsive",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-item clickable wide px-4 create-request-package",
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.bulk-request-modal",
                                      modifiers: { "bulk-request-modal": true },
                                    },
                                  ],
                                  staticClass: "btn btn-white",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application.applicationHeader.createRequestPackage"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-item clickable wide px-4",
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.e-sign-modal",
                                      modifiers: { "e-sign-modal": true },
                                    },
                                  ],
                                  staticClass: "btn btn-white clickable",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application.applicationHeader.createESignPackage"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-item clickable wide px-4",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-white",
                                  attrs: { "data-parsley-required": "false" },
                                  on: { click: _vm.openValidWidgetPopover },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("global.words.validate")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.left",
                                  value: {
                                    title: _vm.noaDisabled,
                                    disabled: !_vm.noaDisabled,
                                  },
                                  expression:
                                    "{\n                  title: noaDisabled,\n                  disabled: !noaDisabled\n                }",
                                  modifiers: { left: true },
                                },
                              ],
                              staticClass: "dropdown-item clickable wide px-4",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-white",
                                  class: { disabled: _vm.noaDisabled },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCRARequestModal()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application.applicationHeader.requestNoa"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "dropdown-divider d-block",
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-item clickable wide px-4",
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.manage-automations-modal",
                                      modifiers: {
                                        "manage-automations-modal": true,
                                      },
                                    },
                                  ],
                                  staticClass: "btn btn-white",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc(
                                          "application.applicationHeader.muteAutomation",
                                          2
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-item clickable wide px-4",
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-white",
                                  on: {
                                    click: _vm.handleChangelogSummaryClick,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-changelog.changelogSummary"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.currentAgentIsCollaborator
                            ? [
                                _c("div", {
                                  staticClass: "dropdown-divider d-block",
                                }),
                                _vm._v(" "),
                                !_vm.linkedProfiles.length
                                  ? _c("add-to-board-dropdown", {
                                      attrs: {
                                        "application-id": _vm.applicationId,
                                        "client-username": _vm.clientUsername,
                                        "agent-username": _vm.agentUsername,
                                        responsive: "",
                                      },
                                    })
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-item clickable wide px-4",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-white",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "note"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.addNote"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-item clickable wide px-4",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-white",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "checklist"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.createChecklist"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-item clickable wide px-4",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-white",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "activity"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.createActivity"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-item clickable wide px-4",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-white",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleOpenQuickActionsModal(
                                                    "email"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationHeader.sendEmail"
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.showApplicationFeatureDiscovery
            ? _c("application-feature-discovery")
            : _vm._e(),
          _vm._v(" "),
          _c("application-changelog", {
            attrs: {
              show: _vm.showChangelog,
              "client-username": _vm.clientUsername,
              "application-id": _vm.applicationId,
              "agent-username": _vm.agentUsername,
            },
            on: {
              "update:show": function ($event) {
                _vm.showChangelog = $event
              },
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }